import api from "../http/api";

export const financeInstitution = async ({
  institutionId,
  startDate,
  endDate,
  knowledgeArea,
  discipline,
  courseTypeId,
  courseGradeId,
  localityId,
  filtermodality,
  filtershift
}) => {
  const queryParams = new URLSearchParams();
  console.log('knowledgeArea', knowledgeArea)

  if (knowledgeArea !== undefined && knowledgeArea !== null) {
    queryParams.append('knowledgeArea', knowledgeArea);
  }

  if (discipline !== undefined && discipline !== null) {
    queryParams.append('discipline', discipline);
  }

  if (courseTypeId !== undefined && courseTypeId !== null) {
    queryParams.append('courseType', courseTypeId);
  }

  if (courseGradeId !== undefined && courseGradeId !== null) {
    queryParams.append('courseGrade', courseGradeId);
  }

  if (localityId !== undefined && localityId !== null) {
    queryParams.append('locality', localityId);
  }

  if (filtermodality !== undefined && filtermodality !== null) {
    queryParams.append('modality', filtermodality);
  }

  if (filtershift !== undefined && filtershift !== null) {
    queryParams.append('shift', filtershift);
  }

  const query = `${startDate ? `?startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}&` : ""
    }`;

  try {
    const response = await api.client.get(
      `api/v1/financeInstitution${query}${queryParams.toString()}`, {
      headers: {
        institutionId: institutionId
      }
    }
    );

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de login");
  }
};

// Série mensal de faturado/recebido de um escopo (instituição + localidade opcional).
// Usada pelo comparativo de receita: uma chamada por lado da comparação.
export const financeRevenueSeries = async ({
  institutionId,
  startDate,
  endDate,
  locality
}) => {
  const queryParams = new URLSearchParams();

  if (startDate) {
    queryParams.append('startDate', startDate);
  }

  if (endDate) {
    queryParams.append('endDate', endDate);
  }

  if (locality) {
    queryParams.append('locality', locality);
  }

  try {
    const response = await api.client.get(
      `api/v1/FinanceInstitution/RevenueSeries?${queryParams.toString()}`, {
      headers: {
        institutionId: institutionId
      }
    }
    );

    return response.data?.series || [];
  } catch (error) {
    throw new Error("Falha ao buscar série de receita para comparação");
  }
};

// Mapa de calor de risco por curso (evasão × inadimplência), vindo das tabelas do preditivo.
// Não recebe período: os dois lados são snapshots (ver comentário no endpoint).
export const financeCourseRiskHeatmap = async ({ institutionId }) => {
  try {
    const response = await api.client.get(
      'api/v1/FinanceInstitution/CourseRiskHeatmap', {
      headers: {
        institutionId: institutionId
      }
    }
    );

    return response.data?.courseRiskHeatmap || null;
  } catch (error) {
    throw new Error("Falha ao buscar o mapa de calor de risco por curso");
  }
};

// Alunos por trás de uma célula do mapa de calor. risk: "dropout" | "delinquency".
export const financeCourseRiskDetails = async ({ institutionId, risk, courseName }) => {
  const queryParams = new URLSearchParams({ risk, courseName });

  try {
    const response = await api.client.get(
      `api/v1/FinanceInstitution/CourseRiskHeatmap/Details?${queryParams.toString()}`, {
      headers: {
        institutionId: institutionId
      }
    }
    );

    return response.data?.courseRiskDetails?.students || [];
  } catch (error) {
    throw new Error("Falha ao buscar o detalhamento de risco do curso");
  }
};

export const financeConsolidatedData = async ({
  institutionId,
  page = 1,
  pageSize = 30,
  searchTerm = "",
  filters = [],
  joins = [],
  startDate = null,
  endDate = null
}) => {
  // Agrupar filtros por groupId
  const groupedFilters = {};
  filters.forEach((filter) => {
    if (filter.field && filter.values && filter.values.length > 0) {
      const groupId = filter.groupId !== undefined ? filter.groupId : 0;
      if (!groupedFilters[groupId]) {
        groupedFilters[groupId] = [];
      }
      groupedFilters[groupId].push(filter);
    }
  });
  
  // Montar filterGroups no formato esperado pela API
  const filterGroups = Object.keys(groupedFilters).map((groupId) => {
    const filtersInGroup = groupedFilters[groupId];
    
    return {
      condition: "AND", // Condição dentro do grupo é sempre AND
      filters: filtersInGroup.map((filter) => ({
        field: filter.field,
        operator: filter.operator || 'eq',
        values: filter.values || [] // filter.values já é um array
      }))
    };
  });
  
  // Montar o body da requisição
  const requestBody = {
    page: page,
    pageSize: pageSize,
    groupCondition: Object.keys(groupedFilters).length > 1 ? "OR" : "AND", // OR entre grupos, AND se só houver um
    filterGroups: filterGroups
  };
  
  // Adicionar searchTerm se existir
  if (searchTerm) {
    requestBody.searchTerm = searchTerm;
  }

  // Adicionar datas se existirem
  if (startDate) {
    requestBody.startDate = startDate;
  }
  if (endDate) {
    requestBody.endDate = endDate;
  }

  // Adicionar joins se existirem
  if (joins && joins.length > 0) {
    requestBody.joins = joins;
  }

  try {
    const response = await api.client.post(
      'api/v1/FinanceInstitution/ConsolidatedData',
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados consolidados:", error);
    throw new Error("Falha na conexão com a API de dados consolidados");
  }
};

export const getSavedFilters = async ({ institutionId }) => {
  try {
    const response = await api.client.get(
      'api/v1/ConsolidatedData/SavedFilters',
      {
        headers: {
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar filtros salvos:", error);
    throw new Error("Falha ao buscar filtros salvos");
  }
};

export const getSavedFilterById = async ({ institutionId, filterId }) => {
  try {
    const response = await api.client.get(
      `api/v1/ConsolidatedData/SavedFilters/${filterId}`,
      {
        headers: {
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar filtro por ID:", error);
    throw new Error("Falha ao buscar filtro");
  }
};

export const createSavedFilter = async ({ institutionId, name, description, tables, filter }) => {
  try {
    const response = await api.client.post(
      'api/v1/ConsolidatedData/CreateFilter',
      {
        name,
        description,
        tables,
        filter
      },
      {
        headers: {
          'Content-Type': 'application/json',
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao criar filtro:", error);
    throw new Error("Falha ao criar filtro");
  }
};
